<cm-sub-header-layout
  [showBreadcrumb]="true"
  [topTitleAutId]="'case-number-display'"
  [title]="caseData().title"
  [chips]="chips()"
  [chipsPosition]="'bottom'"
  [subtitleChips]="subtitleChips()"
  [hasBackButton]="hasBackButton()"
  [customBackHandler]="customBackHandler()"
  (backButtonClick)="backButtonClick.emit()"
>
  <ng-content />
</cm-sub-header-layout>
